var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"mb-3 static-text",attrs:{"type":"flex"}},[_c('div',{staticClass:"label-column"},[_vm._v("\n    "+_vm._s(_vm.$label)+"\n  ")]),_c('div',{staticClass:"value-column"},[_vm._v(_vm._s(_vm.$value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }